import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get the list
 * @param {string} params.orgId - the ID or the org that you want to get the apps for
 * @param {Array<{appId: string; versionId: string}>} params.apps - the list of apps to get the details for
 * @param {'card'|'details'} params.mode - the mode to get the app details in
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'apps', 'orgId'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    apps: { allowedTypes: ['array'] },
    mode: { allowedTypes: ['string'] },
  };

  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }

  const body = {
    appVersionList: params.apps,
  };

  const headers = {
    Authorization: params.accessToken,
    'Content-type': 'application/json',
    Accept:
      params.mode === 'card'
        ? 'application/vnd.adobe.xt.app-card-v1+json'
        : 'application/vnd.adobe.xt.app-detail-v2+json',
    'x-api-key': settings.apiKey,
    'x-org-id': params.orgId,
  };

  const versionsResponse = await fetch(`${settings.endpoint}/v2/versions/search?pageSize=200`, {
    signal,
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  let versionsContent = await versionsResponse.text();
  try {
    versionsContent = JSON.parse(versionsContent);
  } catch (e) {
    // response is not json
  }

  if (!versionsResponse.ok) {
    throw new CallError('http', versionsContent, versionsResponse.status, { message: versionsResponse.statusText });
  } else {
    return versionsContent?.cloudVersions ?? [];
  }
};
